import HTMLMediaElement from '../html-media-element/HTMLMediaElement.js';

/**
 * HTML Audio Element.
 *
 * Reference:
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement.
 *
 */
export default class HTMLAudioElement extends HTMLMediaElement {}
